import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '../../directives/directives.module';
import { SelectDropdownComponent } from './select-dropdown.component';
import { SelectPanelModule } from '../select-panel/select-panel.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [SelectDropdownComponent],
  exports: [SelectDropdownComponent],
  entryComponents: [SelectDropdownComponent],
  imports: [
    CommonModule,
    FormsModule,
    AngularSvgIconModule,
    TranslateModule,
    SelectPanelModule,
    DirectivesModule,
    DropdownModule,
    TooltipModule
  ]
})
export class SelectDropdownModule {}

export { SelectDropdownComponent };
